import TextFieldComponent from '../textfield';

class PhoneNumberComponent extends TextFieldComponent {
  constructor (component, data, options) {
    super(component, data, options);
  }
}

export default PhoneNumberComponent;
